import { j as r } from "./index.es33.js";
import { clsx as s } from "./index.es105.js";
import { Typography as l } from "./index.es35.js";
import "./index.es36.js";
import { PLACEHOLDER_RANGE_FOCUSED as m } from "./index.es652.js";
import e from "./index.es659.js";

var h = function h(_ref) {
  var o = _ref.inputValue;
  return r.jsxs("div", {
    className: e.placeholder,
    style: {
      left: "12px"
    },
    children: [r.jsx(l.Body2, {
      className: s(e.placeholderItem, e.placeholderHidden),
      children: o
    }), r.jsx(l.Body2, {
      className: e.placeholderItem,
      children: "".concat(m.substring(o.length))
    })]
  });
};

export { h as SubstringedPlaceholder };